<template>
  <div>
    <div v-if="$route.path.indexOf('_detail') === -1">
      <el-row :gutter="20">
        <el-col :span="4">
          <el-button type="primary" icon="plus" @click="editInfo()">添加活动图片</el-button>
        </el-col>
      </el-row>
      <el-table :data="iconsData"  v-loading="loading"  @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center" label="全选"></el-table-column>
        <el-table-column prop="id" label="ID" width="130"></el-table-column>
        <el-table-column label="图片" width="100">
          <template slot-scope="scope">
            <el-popover placement="right" width="240" trigger="hover">
            <img :src="scope.row.url" style="width:100%;">
            <el-button type="text" slot="reference"><img style="width:50px;height:50px;" :src="scope.row.url"></el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题" width="130"></el-table-column>
        <el-table-column prop="img_type" label="图片样式" width="130">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.img_type=='1'">长图</el-tag>
            <el-tag v-else-if="scope.row.img_type=='2'" type="danger">竖图</el-tag>
            <el-tag v-else type="success">方图</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="130">
          <template slot-scope="scope">
            <el-button type="text" @click="editInfo(scope.row)" class="btn-gap">编辑</el-button>
            <el-popover
              placement="right"
              width="450"
              trigger="hover">
              <div class="operating-icons">
                <el-button type="text" @click="deleteIconsAction(scope.$index, scope.row)" class="btn-gap">删除</el-button>
              </div>
              <el-button type="text" slot="reference"><i class="iconfont icon-angle-double-right"></i></el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
     <div v-if="total_count > params.pageSize" class="content-padded tc">
      <el-pagination background   layout="prev, pager, next, total" @current-change="handleCurrentChange" :current-page.sync="params.page" :total='total_count' :page-size='params.pageSize'>
      </el-pagination>
    </div>

      <el-dialog  :title="dialogTitle" class="right-dialog" :visible.sync="editInfoDialog" :before-close="handleCancelLabelsDialog">
      <template>
        <el-form>
          <el-form-item label-width="100px" label="标题">
            <el-input v-model="updateForm.title" placeholder="标题"></el-input>
          </el-form-item>
          <el-form-item label-width="100px" label="图片样式">
            <el-radio-group v-model="updateForm.img_type" size="small" @change="changeStatus">
              <el-radio :label="'0'">方图</el-radio>
              <el-radio :label="'1'">长图</el-radio>
              <el-radio :label="'2'">竖图</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label-width="100px" label="图片" prop="url">
            <div @click="handleImgPicker('url')" class="upload-box">
              <img v-if="updateForm.url" :src="updateForm.url" class="avatar"/>
              <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
            </div>
            <!-- <div class="frm-tips">
              只能上传jpg/png文件，且不超过2M
            </div> -->
          </el-form-item>

          <el-form-item class="content-center">
            <el-button type="primary" @click="editInfoSubmit()">确定</el-button>
          </el-form-item>
        </el-form>
      </template>
    </el-dialog>

    <imgPicker
      :dialog-visible="imgDialog"
      :sc-status="isGetImage"
      @chooseImg="pickImg"
      @closeImgDialog="closeImgDialog"
    ></imgPicker>

    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import {deleteIcons, iconsList, updateIcon} from '../../../api/sharer'
import imgPicker from '@/components/imageselect'
export default {
  components: { imgPicker },
  data () {
    return {
      total_count: 0,
      dialogTitle: '',
      loading: false,
      iconsData: [],
      params: {
        page: 1,
        pageSize: 20
      },
      updateForm: {
        id: '',
        title: '',
        url: '',
        img_type: '0'
      },
      editInfoDialog: false,
      pickerImgType: '',
      imgDialog: false,
      isGetImage: false
    }
  },
  methods: {
    getIcons (filter) {
      this.loading = true
      iconsList(filter).then(response => {
        this.iconsData = response.data.data.list
        this.total_count = Number(response.data.data.total_count)
        this.loading = false
      })
    },
    editInfo (row = '') {
      this.editInfoDialog = true
      if (row) {
        this.updateForm.id = row.id
        this.updateForm.title = row.title
        this.updateForm.url = row.url
        this.updateForm.img_type = row.img_type
        this.dialogTitle = '编辑活动图片'
      } else {
        this.dialogTitle = '添加活动图片'
        this.updateForm = {id: '', title: '', url: '', img_type: '0'}
      }
    },
    changeStatus (value) {
        this.updateForm.img_type = value
    },
    editInfoSubmit () {
      // console.log(this.updateForm);
      updateIcon({id: this.updateForm.id, title: this.updateForm.title, url: this.updateForm.url, img_type: this.updateForm.img_type}).then(res => {
        this.$message({ type: 'success', message: '更新成功'})
        this.editInfoDialog = false
        this.getIcons(this.params)
      })
    },
    deleteIconsAction (index, row) {
      this.$confirm('此操作将删除该条活动图片, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteIcons(row.id).then(response => {
          if (response.data.data && response.data.data.status) {
            this.iconsData.splice(index, 1)
            this.$message({
              message: '删除活动图片成功',
              type: 'success',
              duration: 2 * 1000
            })
          } else {
            this.$message({
              type: 'info',
              message: '删除活动图片失败'
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    handleCancelLabelsDialog () {
      this.editInfoDialog = false
    },
    pickImg (data) {
      this.updateForm[this.pickerImgType] = data.url
      // this.updateForm.url = data.url;
      this.imgDialog = false
    },
    handleImgPicker (pickerImgType) {
      this.pickerImgType = pickerImgType
      this.imgDialog = true
      this.isGetImage = true
    },
    closeImgDialog () {
      this.imgDialog = false
      this.isGetImage = false
    },
    handleSelectionChange (val) {
      console.log(val)
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getIcons(this.params)
    }
  },
  mounted () {
    this.getIcons(this.params)
    let param = {
      page: 1,
      pageSize: 100
    }
  },
  watch: {
    // 分页全选-监听数据变化
    iconsData: {
      handler (value) {
        if (this.allCheck) {
          this.iconsData.forEach(row => {
            if (row) {
              this.$refs.multipleTable.toggleRowSelection(row, true)
            }
          })
        }
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// icons_list.vue?64d86b2e